// extracted by mini-css-extract-plugin
module.exports = {"container":"OfferBanner_healthgenom_container__1w6uc","icon":"OfferBanner_healthgenom_icon__2XlrG","link":"OfferBanner_healthgenom_link__2dehs"};